import { IUser } from '../models/IUser';
import { ApiState } from '@models/api-state';

export interface IUserState {
  userData: IUser | null;
  apiState: ApiState;
}

export const initialUserState: IUserState = {
  userData: null,
  apiState: 'Unknown',
};
